import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { PDFDocument } from 'pdf-lib';

export const modalCloseListener = (modalId, callback) => {
  const modalElement = document.getElementById(modalId);

  if (!modalElement) {
    console.error(`Modal with ID "${modalId}" not found.`);
    return;
  }

  const handleModalClose = () => {
    callback();
  };

  modalElement.addEventListener("hidden.bs.modal", handleModalClose);

  // Return a cleanup function to remove the event listener
  return () => {
    modalElement.removeEventListener("hidden.bs.modal", handleModalClose);
  };
};

// *For Generate PDF
export const generatePdf = async (refs, type) => {
  try {
    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'pt',
      format: 'letter',
    });

    const canvasPromises = refs?.map(ref =>
      html2canvas(ref.current, {
        scale: 2,
        scrollX: 0,
        scrollY: 0,
      })
    );

    const canvases = await Promise.all(canvasPromises);

    canvases.forEach((canvas, index) => {
      const imgData = canvas.toDataURL("image/png", 1.0);
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

      if (index > 0) pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, Math.min(imgHeight, pdfHeight));

      pdf.setTextColor(150, 150, 150, 0.3);
      pdf.setFontSize(150);
      pdf.setFont('helvetica', 'bold');

      pdf.saveGraphicsState();
      pdf.setGState(new pdf.GState({ opacity: 0.2 }));

      pdf.text(
        'COD',
        pdfWidth / 1.7,
        pdfHeight / 1.5,
        { align: 'center', angle: 45 }
      );

      pdf.restoreGraphicsState();

    });

    let blob;
    if (type === 'sale-invoice') {
      const newPdfBytes = pdf.output('arraybuffer');

      // Merge PDFs
      const mergedPdfBytes = await mergePdfs(newPdfBytes);

      blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
    } else {

      blob = pdf.output("blob");
    }

    const blobURL = URL.createObjectURL(blob);
    const newWindow = window.open('', '_blank');

    if (newWindow) {
      newWindow.document.write(`
      <html>
        <head>
          <title>Invoice</title>
        </head>
        <body style="margin:0">
          <iframe src="${blobURL}" style="width:100%;height:100vh;border:none;" onload="this.contentWindow.print()"></iframe>
        </body>
      </html>
    `);
      newWindow.document.close();
    }
  } catch (error) {
    console.log(' generatePdf => error:', error)
  }
}

// *For Merge PDF
const mergePdfs = async (newPdfBytes) => {
  try {
    const existingPdfBytes = await fetch('/assets/pdf/mattress-plus-policy.pdf').then(res => res.arrayBuffer());

    // Load existing PDF
    const existingPdf = await PDFDocument.load(existingPdfBytes);

    // Load new PDF
    const newPdf = await PDFDocument.load(newPdfBytes);

    // Create a new PDFDocument
    const mergedPdf = await PDFDocument.create();

    // Copy pages from new PDF
    const [newPdfPage] = await mergedPdf.copyPages(newPdf, newPdf.getPageIndices());
    mergedPdf.addPage(newPdfPage);

    // Copy pages from existing PDF
    const [existingPdfPage] = await mergedPdf.copyPages(existingPdf, existingPdf.getPageIndices());
    mergedPdf.addPage(existingPdfPage);

    // Serialize the merged PDF to bytes
    const mergedPdfBytes = await mergedPdf.save();
    return mergedPdfBytes;
  } catch (error) {
    console.log(' mergePdfs => error:', error)
  }
};